var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['Loader', _vm.props.theme, _vm.data.class, _vm.data.staticClass]})}
var staticRenderFns = []

export { render, staticRenderFns }